<form [formGroup]="form" (ngSubmit)="save()" [method]="'post'" *ngIf="isInitialized" class="form--standalone">
  <swb-form-fields [fields]="FormEditors" [form]="form"></swb-form-fields>
</form>